import { useState } from "react";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Notification } from "react-migration/components/Notification";
import { ModalV2 } from "react-migration/components/ModalV2/ModalV2";

import { TopupFlow } from "./TopupFlow";
import { useSnapshot } from "valtio";
import { mapStore } from "src/js/stores/map/store";

export const TopupModal = ({
  setShowTopupModal,
  options,
}: {
  setShowTopupModal: (v: boolean) => void;
  options?: { initialAmount?: number };
}) => {
  const { t } = useTranslation();
  const [paymentComplete, setPaymentComplete] = useState(false);
  const { settings } = useSnapshot(mapStore);

  const handlePaymentComplete = () => {
    setPaymentComplete(true);
  };

  return (
    <ModalV2.Root defaultOpen={true} onOpenChange={setShowTopupModal}>
      <ModalV2.Body
        title="Topup"
        className="z-99999!"
        contentClassName="w-[500px]!"
        descriptionClassName="overflow-visible!"
        disableClose={settings.paymentProcessing}
      >
        {!paymentComplete && (
          <TopupFlow initialAmount={options?.initialAmount} onPaymentComplete={handlePaymentComplete} />
        )}
        {paymentComplete && (
          <Notification.Success
            additionalClassName="w-[440px] mt-4"
            title={t("dashboard.topup.payment_complete")}
            message={t("dashboard.topup.payment_complete_text")}
            icon="check"
          />
        )}
      </ModalV2.Body>
    </ModalV2.Root>
  );
};
